
<ng-select 
    (change)="onSelectElement()" 
    (scrollToEnd)="onGetMoreItems()" 
    (search)="onSearch($event)"
    [(ngModel)]="medicament" 
    placeholder="Rechercher un médicament..."
    name="medicament"
    [multiple]="false" 
    [closeOnSelect]="true"
    [searchable]="true"
    [clearable]="true"
    [virtualScroll]="true"
    class="medicament-selector"
    appendTo="body">
    
    <ng-option *ngFor="let item of items" [value]="item" style="border: solid;">
        <div class="medication-option"  [ngClass]="{
            'option-entente-prealable': item.is_entente_prealable,
            'option-non-garanti': item.is_exclu,
            'option-garanti': !item.is_exclu && !item.is_entente_prealable 
          }">
            <div class="medication-name">{{ item.libelle }}</div>
            <div class="medication-details" *ngIf="item.forme_medicament_libelle || item.dci">
                <span class="badge bg-light text-dark me-2" *ngIf="item.forme_medicament_libelle">
                    {{ item.forme_medicament_libelle }}
                </span>
                <span class="text-muted small" *ngIf="item.dci">{{ item.dci }}</span>
            </div>
            <div class="medication-status">
                <span class="status-badge" *ngIf="item.is_entente_prealable">
                    <i class="fas fa-exclamation-triangle me-1"></i>Entente préalable
                </span>
                <span class="status-badge" *ngIf="item.is_exclu">
                    <i class="fas fa-times-circle me-1"></i>Non garanti
                </span>
            </div>
        </div>
    </ng-option>
    
    <ng-template ng-label-tmp let-item="item">
        <div class="selected-medication">
            <span class="medication-name">{{ item.libelle }}</span>
            <span class="badge ms-2" [ngClass]="{
                'bg-warning': item.is_entente_prealable,
                'bg-danger': item.is_exclu,
                'bg-success': !item.is_exclu && !item.is_entente_prealable
            }">
                {{ item.is_entente_prealable ? 'Entente préalable' : item.is_exclu ? 'Non garanti' : 'Garanti' }}
            </span>
        </div>
    </ng-template>
    
    <ng-template ng-option-tmp let-item="item" let-index="index">
        <div class="medication-option" [ngClass]="{
            'option-entente-prealable': item.is_entente_prealable,
            'option-non-garanti': item.is_exclu,
            'option-garanti': !item.is_exclu && !item.is_entente_prealable 
          }">
            <div class="medication-name">{{ item.libelle }}</div>
            <div class="medication-details">
                <span class="badge bg-light text-dark me-2" *ngIf="item.forme_medicament_libelle">
                    {{ item.forme_medicament_libelle }}
                </span>
                <span class="text-muted small" *ngIf="item.dci">{{ item.dci }}</span>
            </div>
        </div>
    </ng-template>
</ng-select>